import { RoundupDriverGroupEnum } from '@repo/contracts/marketplace/offers/enums';
import type { BranchId } from './constants';

export const BRANCH_DRIVER_GROUP_MAP: Record<BranchId, RoundupDriverGroupEnum> = {
  travel: RoundupDriverGroupEnum.Rewards,
  cash_back: RoundupDriverGroupEnum.Rewards,
  balance_transfer: RoundupDriverGroupEnum.BalanceTransfer,
  saving_interest: RoundupDriverGroupEnum.Default,
  building_credit: RoundupDriverGroupEnum.Subprime,
};
